module.exports = __webpack_public_path__ + "static/netad-logo-07684986268ee9de709daaa6f6c42e32.png";